import { withClientErrorPage } from '@sm/webassets';
import ForbiddenError from './ForbiddenError';

export default withClientErrorPage(ForbiddenError, { titularElementTag: 'h1' });
